// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {
    var suggestionElement = this.$uiMenuElement;
    var searchElement = this.$element;
    var searchBoxId = this.id;
  };

  InstantSearchApi.beforeCall = function (searchTerm) {
      Globals.instantSearchQueryParams.h_options = [];
      if (Shopify.country == 'NZ' || Shopify.country == 'nz') {
        Globals.instantSearchQueryParams.h_options.push('exclude_nz');
      }

    if (Shopify.country == 'AU' || Shopify.country == 'au') {
        Globals.instantSearchQueryParams.h_options.push('exclude_aus');
      }
    }
})();